module.exports = __webpack_public_path__ + "img/minipass_purple.9964dfd9.png";